// extracted by mini-css-extract-plugin
export default {"avatar-button":"AvatarButton_avatar-button__ny+0M"};